export const NIGHT_PERDIEM = 'nuit';
export const AM_PERDIEM = 'am';
export const PM_PERDIEM = 'pm';
export const EVENING_PERDIEM = 'soir';
export const TRAINING_HALF_DAY_CLAIMED_AMOUNT = 422;
